import React from 'react'
import {useUserProfileContext} from '../../../context/UserProfileContext'
import {useHistory} from 'react-router-dom'
import { defaultProfileImage } from '../../../utils/constants'
import { formatPhone } from '../../../helpers/FormatInputs'

export interface Member {
  id: string
  firstName: string
  lastName: string
  profilePicture: string
  email: string
  phoneNumber: string
  addedOn: string
  plan: string
  assignedTo: string
  roleName: string,
  statusLabel: string
}

interface MembersTableProps {
  members: Member[]
  loading: boolean
  page: number
  limit: number
  onRowClick?: (id: string) => void
}

export const ManageAdminGrid: React.FC<MembersTableProps> = ({members, loading, page, limit, onRowClick}) => {
  const {setSearchParams} = useUserProfileContext()
  const navigate = useHistory()

  if (loading) return <div>Loading...</div>
  if (!members?.length) return <div className='members-page__no-results'>No results found</div>

  const handleClickCell = (id: string) => {
    setSearchParams({userSelected: id});
  }

  return (
    <div className='members-admins-table'>
      <div className='members-admins-table__header-row'>
        <div className='members-admins-table__header'>ID</div>
        <div className='members-admins-table__header'>Name</div>
        <div className='members-admins-table__header'>Email</div>
        <div className='members-admins-table__header'>Phone Number</div>
        <div className='members-admins-table__header'>Added On</div>
        <div className='members-admins-table__header'>Roles</div>
        <div className='members-admins-table__header'>Status </div>
      </div>

      {members.map((member,index) => (
        <div
          key={member.id}
          className='members-admins-table__row'
          onClick={() => onRowClick?.(member.id)}
        >
          <div className='members-admins-table__cell'>{(page - 1) * limit + index + 1}</div>
          <div className='members-admins-table__cell card-profile-avatar'>
            <img src={member.profilePicture || defaultProfileImage} onError={(e)=>e.currentTarget.src = defaultProfileImage} />
            <span>{member.firstName} {member.lastName}</span>
          </div>
          <div className='members-admins-table__cell'>{member.email}</div>
          <div className='members-admins-table__cell'>{formatPhone(member.phoneNumber)}</div>
          <div className='members-admins-table__cell'>{member.addedOn}</div>
          <div className='members-admins-table__cell'>{(member.roleNames || []).join(', ')}</div>
          <div className='members-admins-table__cell'>{member.statusLabel}</div>
        </div>
      ))}
    </div>
  )
}
